module.exports = __webpack_public_path__ + "static/media/Something went wrong.99bc1530.jpg";